import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';

import { Route, NavLink } from 'react-router-dom';
import Data from './router/Data'
import { Provider } from '../context/Context'

import { Container, Search, Card, Sidebar, Menu, Icon, Grid, Image, Segment, Header, Button } from 'semantic-ui-react'


import './static/App.css';


const App = () => {
  return (

    // <Fragment>
      <Provider>

        <Data />

      </Provider>

    // </Fragment>


  );
}


// class App extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       animation: 'overlay',
//       direction: 'left',
//       dimmed: false,
//       visible: false,
//     }
//   }


//   handleAnimationChange = (animation) => () =>
//     this.setState((prevState) => ({ animation, visible: !prevState.visible }), this.handleDirectionChangeTrue('left'))

//   handleDimmedChange = (e, { checked }) => (this.setState({ dimmed: checked }))

//   handleDirectionChange = (direction) => () =>
//     this.setState({ direction, visible: false })

//   handleDirectionChangeTrue = (direction) => () =>
//     this.setState({ direction, visible: true })



//   ButtonMultipleConditionals = () => (
//     <Button.Group style={{ align: "center" }}>
//       <Button onClick={this.handleAnimationChange('push')}>Open Menu</Button>
//       <Button.Or />
//       {/* <Button onClick={this.handleAnimationChange('overlay')}>Two</Button>
//       <Button.Or />
//       <Button onClick={this.handleAnimationChange('scale down')}>Three</Button>
//       <Button.Or /> */}
//       <Button onClick={this.handleDirectionChange('left')}
//       >Close Menu</Button>
//     </Button.Group>
//   )


  
//   render() {
//     const { animation, dimmed, direction, visible } = this.state
//     const vertical = direction === 'bottom' || direction === 'top'
//     return (
//       <div className="App">
//         <Provider>
//         {this.ButtonMultipleConditionals()}
//         <Sidebar.Pushable as={Segment}>
//         <HorizontalSidebar
//               animation={animation}
//               direction={direction}
//               visible={visible}
//             >

              
//             </HorizontalSidebar>


      
            
      

//           {/* <FilesProvider> */}
//           <Data />
//           {/* </FilesProvider> */}
//           </Sidebar.Pushable>
//         </Provider>

//       </div>
//     )
//   }



  
// }
 


// const NavLinkWithChildrenFunc = ({ to, exact = false, children, ...rest }) => (
//   <Route path={to} exact={exact}>
//     {({ match }) => (
//       <NavLink to={to} {...rest}>
//         {typeof children === "function" ? children(match) : children}
//       </NavLink>
//     )}
//   </Route>
// );


// const VerticalSidebar = ({ animation, direction, visible }) => (
//   <Sidebar
//     as={Menu}
//     animation={animation}
//     direction={direction}
//     icon='labeled'
//     // inverted
//     vertical
//     visible={visible}
//     width='thin'
//   >


//     <NavLinkWithChildrenFunc exact to="/cardlist/card/add">
//       {match => (
//         <Menu.Item active={!!match}>
//           <Icon name="wpforms" />
//           Create a new Project
//                 </Menu.Item>
//       )}
//     </NavLinkWithChildrenFunc>


//     <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="users" />
//       Members in your Organization
//             </Menu.Item>
//     <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="hospital outline" />
//       Organiztion
//             </Menu.Item>
//     <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="address card" />
//       Your Profile
//             </Menu.Item>
//     <NavLinkWithChildrenFunc exact to="/">
//       {match => (
//         <Menu.Item active={!!match}>
//           <Icon name="home" />
//           Home
//                 </Menu.Item>
//       )}
//     </NavLinkWithChildrenFunc>

//     <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="log out" />
//       Logout
//             </Menu.Item>


//   </Sidebar>
// )

// VerticalSidebar.propTypes = {
//   animation: PropTypes.string,
//   direction: PropTypes.string,
//   visible: PropTypes.bool,
// }


// as={Menu}
// animation={animation}
// direction={direction}
// icon='labeled'
// // inverted
// vertical
// visible={visible}
// width='thin'


// const HorizontalSidebar = ({ animation, direction, visible }) => (
//   <Sidebar
//     as={Menu}
//     animation={animation}
//     direction={direction}
//     visible={visible}
//     vertical
//   >
//    <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="log out" />
//       Logout
//             </Menu.Item>
//             <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="log out" />
//       Logout
//             </Menu.Item>
//             <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="log out" />
//       Logout
//             </Menu.Item>
//             <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="log out" />
//       Logout
//             </Menu.Item>
//             <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="log out" />
//       Logout
//             </Menu.Item>
//             <Menu.Item style={{ cursor: "pointer" }}>
//       <Icon name="log out" />
//       Logout
//             </Menu.Item>
//   </Sidebar>
// )


// const HorizontalSidebar = ({ animation, direction, visible }) => (
//   <Sidebar
//     as={Segment}
//     animation={animation}
//     direction={direction}
//     visible={visible}
//   >
//     <Grid textAlign='center'>
//       <Grid.Row columns={1}>
//         <Grid.Column>
//           <Header as='h3'>New Content Awaits</Header>
//         </Grid.Column>
//       </Grid.Row>
//       <Grid columns={3} divided>
//         <Grid.Column>
//           <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' />
//         </Grid.Column>
//         <Grid.Column>
//           <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' />
//         </Grid.Column>
//         <Grid.Column>
//           <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' />
//         </Grid.Column>
//       </Grid>
//     </Grid>
//   </Sidebar>
// )

// HorizontalSidebar.propTypes = {
//   animation: PropTypes.string,
//   direction: PropTypes.string,
//   visible: PropTypes.bool,
// }




export default App;

